// ErrorBoundary.tsx
import React from 'react';
import errorBackground from './assets/images/icons/errorBoundry1.svg'
import errorMain from './assets/images/icons/errorBoundry2.svg'
import { Box, Stack, Typography } from '@mui/material';
export class ErrorBoundary extends React.Component {
  state = { hasError: false };

  componentDidCatch(error) {
    if (error?.message?.includes('Unexpected') || error?.stack?.includes('persist')) {
      localStorage.removeItem('persist:root');
      window.location.reload(); // fallback
    }
    this.setState({ hasError: true });
  }
  render() {
    return this.state.hasError ? (
      <>
      <Stack sx={{height:'100vh',width:'100%',}} direction={"column"} justifyContent="center" alignItems="center">
<Box sx={{backgroundImage:`url(${errorBackground})`,height:'540px',width:"540px",backgroundRepeat:'no-repeat',backgroundPosition:'center'}} border={'0px solid red'}>
<img src={errorMain} alt="" />
</Box>
<Typography fontFamily={"var(--family2) !important"} fontSize={48} fontWeight={600}>
Oops! Something went wrong.
</Typography>
<Typography fontFamily={"var(--family1)"} fontSize={16} fontWeight={400}>
"The page you’re looking for isn’t available in this browser. For easier access, please switch browsers or use incognito mode."
</Typography>
      </Stack>
      </>
    ) : this.props.children;
  }
}
